import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { sel } from '../../store/studioStore';
import LeftPanel from '../LeftPanel/LeftPanel';
import RightPanel from '../RightPanel/RightPanel';

export default function UnifiedSidebar({
  onAddImage,
  onOpenBg,
  onForkPage,
  scheduleSave,
  showAlert,
}) {
  const [activeTab, setActiveTab] = useState('elements');
  const selected = useSelector(sel.selectedElements);
  const bgSelected = useSelector(sel.bgSelected);

  // Auto-switch to Properties when an element or background is selected
  useEffect(() => {
    if (selected.length > 0 || bgSelected) {
      setActiveTab('properties');
    }
  }, [selected, bgSelected]);

  const tabBtn = (tab, label) => ({
    flex: 1,
    padding: '10px 0',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    color: activeTab === tab ? 'var(--sp-blue)' : 'var(--sp-muted)',
    borderBottom:
      activeTab === tab ? '2px solid var(--sp-blue)' : '2px solid transparent',
    transition: 'all 0.15s',
    fontFamily: 'inherit',
  });

  return (
    <aside
      className="sp-aside"
      style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
    >
      {/* Tab bar */}
      <div
        style={{
          display: 'flex',
          borderBottom: '1px solid var(--sp-line)',
          flexShrink: 0,
          background: '#fff',
        }}
      >
        <button
          style={tabBtn('elements')}
          onClick={() => setActiveTab('elements')}
        >
          Éléments
        </button>
        <button
          style={tabBtn('properties')}
          onClick={() => setActiveTab('properties')}
        >
          Propriétés
        </button>
      </div>

      {/* Tab: Elements — LeftPanel content */}
      <div
        style={{
          display: activeTab === 'elements' ? 'flex' : 'none',
          flexDirection: 'column',
          flex: 1,
          overflowY: 'auto',
        }}
      >
        <LeftPanel
          onAddImage={onAddImage}
          onOpenBg={onOpenBg}
          onForkPage={onForkPage}
          scheduleSave={scheduleSave}
          showAlert={showAlert}
        />
      </div>

      {/* Tab: Properties — RightPanel content */}
      <div
        style={{
          display: activeTab === 'properties' ? 'flex' : 'none',
          flexDirection: 'column',
          flex: 1,
          overflowY: 'auto',
        }}
      >
        <RightPanel scheduleSave={scheduleSave} />
      </div>
    </aside>
  );
}

UnifiedSidebar.propTypes = {
  onAddImage: PropTypes.func.isRequired,
  onOpenBg: PropTypes.func.isRequired,
  onForkPage: PropTypes.func.isRequired,
  scheduleSave: PropTypes.func.isRequired,
  showAlert: PropTypes.func,
};
